import React, { createContext, useContext, useState } from 'react';

type ModalStateType = Record<string, boolean>;

type ModalContextType = {
	modals: ModalStateType;
	handleModal: (modalName: string, action: 'open' | 'close', data?: unknown) => void;
	selectedData: unknown;
};

const ModalContext = createContext<ModalContextType>({
	modals: {},
	handleModal: () => {},
	selectedData: null,
});

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
	const [modals, setModals] = useState<ModalStateType>({});
	const [selectedData, setSelectedData] = useState<unknown>(null);

	const handleModal = (modalName: string, action: 'open' | 'close', data?: unknown) => {
		if (!!data) {
			setSelectedData(data);
		}

		setModals((prev) => ({
			...prev,
			[modalName]: action === 'open',
		}));
	};

	return <ModalContext.Provider value={{ modals, handleModal, selectedData }}>{children}</ModalContext.Provider>;
};

const useModals = () => {
	const context = useContext(ModalContext);
	if (!context) {
		throw new Error('useModals must be used within ModalProvider');
	}
	return context;
};

export default useModals;
